import { BaseApiService } from "@mirage/services/BaseApiService";
import { IBcApplication } from "@shared/publicportal/entities/IBcApplication";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { IEntityPageResult } from "@shared/mirage/core/contracts/IEntityPageResult";
import { IBuildingRegulationsDetails } from "@shared/publicportal/contracts/IBuildingRegulationsDetails";
import { IBuildingRegulationsFilteringLists } from "@shared/publicportal/contracts/IBuildingRegulationsFilteringLists";
import { IBuildingRegulationsService } from "@shared/publicportal/services/IBuildingRegulationsService";

export default class BuildingRegulationsService extends BaseApiService implements IBuildingRegulationsService {
    constructor() {
        super("publicportal/buildingRegulations");
    }

    async getFilteringLists(): Promise<IBuildingRegulationsFilteringLists> {
        const existingFilters = sessionStorage.getItem("publicportal.BuildingRegulationsService.dictionaries");
        if (!existingFilters) {
            const response = await this.httpInstance().get("/filters");
            const filters = response.data;
            sessionStorage.setItem("publicportal.BuildingRegulationsService.dictionaries", JSON.stringify(filters));
            return filters;
        }
        return JSON.parse(existingFilters);
    }

    async getBcAppById(id: number): Promise<IBuildingRegulationsDetails> {
        const response = await this.httpInstance().get(`/${id}`);
        return response.data;
    }

    async pageRequest(pr: IEntityPageRequest): Promise<IEntityPageResult<IBcApplication>> {
        const response = await this.httpInstance().post("/pageRequest", pr);
        return response.data;
    }
}
